import React from "react"
import Relay from "react-relay"
import ResultMedia from "./ResultMedia"
import {
  resourceFileFragment,
  getImageData,
  getPlaceholder
} from "../../scripts/resource"
import { injectIntl } from "react-intl"
import settingsMessages from "../../messages/settings"

class ArticleResultMedia extends React.Component {
  getImages = () => {
    const resource = this.props.resource
    const resources = [resource].concat(
      "children" in resource ? resource.children.edges.map(child => child.node) : [],
      "collected" in resource && "edges" in resource.collected ? resource.collected.edges.map(child => child.node) : []
    )

    return resources.reduce((images, resource) => {
      const image = getImageData(resource)
      if (image) {
        images.push(image)
      }
      return images
    }, [])
  }

  getCoverImage = files => files.find(item => item.type === "cover_image")

  render() {
    const {
      resource: {
        title,
        id,
        type = "collection",
        type_icon: typeIcon,
        type_icon_color: typeIconColor,
        files,
        // children: { total: totalChildren },
        // collected: { total: totalCollected }
      },
      itemUrl: itemUrlProp,
      intl
    } = this.props

    const basePath = type === "collection" ? "/collections/" : "/item/"
    const itemUrl = itemUrlProp || `${basePath}${id}`

    const resource = this.props.resource
    const collectionCoverImage = "cover_image" in resource && resource.cover_image ? resource.cover_image.medium.url : undefined

    return (
      <ResultMedia
        title={title}
        linkTo={itemUrl}
        resultType={type}
        images={this.getImages()}
        placeholder={getPlaceholder(
          type,
          intl.formatMessage(settingsMessages.authenticAccountId)
        )}
        // total={totalChildren + totalCollected}
        coverImage={this.getCoverImage(files || []) || collectionCoverImage}
        icon={typeIcon}
        iconColor={typeIconColor}
      />
    )
  }
}

export default Relay.createContainer(injectIntl(ArticleResultMedia), {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        title
        type
        ${resourceFileFragment}
        children (first: 7) {
          edges {
            node {
              ${resourceFileFragment}
            }
          }
          total
        }
        collected (first: 7) {
          edges {
            node {
              ${resourceFileFragment}
            }
          }
          total
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/elements/ArticleResultMedia.js